module.exports = __webpack_public_path__ + "img/73c450a.svg";